module.exports = __webpack_public_path__ + "img/horizontal_7_6_3009.6a75018a.png";